export {
  isClerkAPIResponseError,
  isClerkRuntimeError,
  isEmailLinkError,
  isKnownError,
  isMetamaskError,
  EmailLinkErrorCode,
} from '@clerk/shared/error';
